// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f2d20778","453":"1c4a1b5e"}[chunkId] + ".chunk.js";
};